import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

// A mono section label with a small accent tick — the landing site's structural
// eyebrow, styled like a drawing callout. The tick is the one place the accent
// appears outside the primary CTA. Brought into the app so its marketing surfaces
// share the same label language as branchcad.com.
export default function Eyebrow({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <span className={cn('brand-eyebrow inline-flex items-center gap-2.5 text-muted-foreground', className)}>
      <span aria-hidden="true" className="size-[7px] shrink-0 rounded-[2px] bg-primary" />
      {children}
    </span>
  );
}
